export default __webpack_public_path__ + "static/media/daihatsu.a291f911.svg";